import { TYPE_CATEGORIES } from "./catalog";
import { formatSiNumber } from "../seo/formatPublished";

const CATEGORY_BY_LABEL = {};
TYPE_CATEGORIES.forEach((category) => {
  category.typeLabels.forEach((label) => {
    CATEGORY_BY_LABEL[label] = category.id;
  });
});

export const PAYLOAD_BANDS = [
  { id: "under-500", label: "under 500 kg" },
  { id: "500-to-1500", label: "500 to 1,500 kg" },
  { id: "over-1500", label: "over 1,500 kg" },
];

export const SORTS = [
  { id: "catalogue", label: "Catalog order" },
  { id: "payload-asc", label: "Payload, low to high" },
  { id: "payload-desc", label: "Payload, high to low" },
  { id: "vendor", label: "Vendor, A to Z" },
  { id: "type", label: "Type" },
];

export function displaySpec(value, unit) {
  if (value === null || value === undefined || value === "") return "Not published";
  if (Array.isArray(value)) {
    return value.length ? value.join(", ") : "Not published";
  }
  if (typeof value === "number") {
    return unit ? `${formatSiNumber(value)} ${unit}` : formatSiNumber(value);
  }
  return String(value);
}

export function payloadBand(payloadKg) {
  if (payloadKg < 500) return "under-500";
  if (payloadKg <= 1500) return "500-to-1500";
  return "over-1500";
}

function uniqueInOrder(values) {
  const seen = new Set();
  const result = [];
  values.forEach((value) => {
    if (!value || seen.has(value)) return;
    seen.add(value);
    result.push(value);
  });
  return result;
}

export function typeOptions(robots) {
  return uniqueInOrder(robots.map((robot) => robot.typeLabel));
}

export function vendorOptions(robots) {
  return uniqueInOrder(robots.map((robot) => robot.vendor));
}

export function navigationOptions(robots) {
  return uniqueInOrder(robots.flatMap((robot) => robot.navigation || []));
}

export function jobCount(robots, jobSlug) {
  return robots.filter((robot) => robot.jobs.includes(jobSlug)).length;
}

export function categoryCount(robots, category) {
  return robots.filter((robot) => category.typeLabels.includes(robot.typeLabel)).length;
}

export function machineVisible(robot, filters) {
  if (filters.types.length && !filters.types.includes(CATEGORY_BY_LABEL[robot.typeLabel])) return false;
  if (filters.vendors.length && !filters.vendors.includes(robot.vendor)) return false;
  if (filters.payloadBands.length && !filters.payloadBands.includes(payloadBand(robot.payloadKg))) {
    return false;
  }
  if (filters.navigation.length) {
    const methods = robot.navigation || [];
    if (!filters.navigation.some((method) => methods.includes(method))) return false;
  }
  if (filters.jobs && filters.jobs.length && !filters.jobs.some((job) => robot.jobs.includes(job))) return false;
  return true;
}

function asciiLower(value) {
  return String(value).replace(/[A-Z]/g, (char) => String.fromCharCode(char.charCodeAt(0) + 32));
}

function compareAscii(left, right) {
  const a = asciiLower(left);
  const b = asciiLower(right);
  if (a < b) return -1;
  if (a > b) return 1;
  return 0;
}

export function sortMachines(robots, sort) {
  if (!sort || sort === "catalogue") return robots.slice();
  return robots
    .map((robot, index) => ({ robot, index }))
    .sort((left, right) => {
      let result = 0;
      if (sort === "payload-asc") result = left.robot.payloadKg - right.robot.payloadKg;
      if (sort === "payload-desc") result = right.robot.payloadKg - left.robot.payloadKg;
      if (sort === "vendor") result = compareAscii(left.robot.vendor, right.robot.vendor);
      if (sort === "type") result = compareAscii(left.robot.typeLabel, right.robot.typeLabel);
      return result || left.index - right.index;
    })
    .map((item) => item.robot);
}

export function toggleValue(list, value) {
  return list.includes(value) ? list.filter((item) => item !== value) : [...list, value];
}
